//Author Matthew Rogers
var StatusChangeService = (function () {
    function StatusChangeService($rootScope, $timeout, $q, socket, env, config, $mdDialog, DTS, Dialog, settings, notify) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.socket = socket;
        this.env = env;
        this.config = config;
        this.$mdDialog = $mdDialog;
        this.DTS = DTS;
        this.Dialog = Dialog;
        this.settings = settings;
        this.notify = notify;
        this.mainStatusChange = false; //if true the status SAVE button should not be visible
        this.disableApproveButtons = false;
        this.ASSIST_VALUES = ['CVR Sales Assist', 'Sales Assist'];
        this.OPP_VERSION_4 = 4;
    }
    StatusChangeService.prototype.refreshChecklists = function (bundle) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                chkBundle: bundle,
                function: 'refreshChecklists',
                script: '/config/config',
                user: this.env.user
            }
        });
    };
    StatusChangeService.prototype.createDispute = function (bundle) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                disBundle: bundle,
                function: 'createDispute',
                script: '/disputes/disputes',
                user: this.env.user
            }
        });
    };
    /**
     * isRollBackAction - Function to determine whether the approval action in process is a Rejection,
     * Cancellation or Reversal.
     *
     * @param  {type} action: string The Approval process action
     * @return {type}                Returns true if Reject, Cancel Approval or Reverse Approval
     */
    StatusChangeService.prototype.isRollBackAction = function (action) {
        if (['Reject', 'Cancel Approval', 'Reverse Approval'].indexOf(action) > -1) {
            return true;
        }
        return false;
    };
    /**
     * nonAppStatusChange - Function for handling main status changes other than Approval stages, ie:
     * Received to Validation...Validation/Received to Rejected etc
     *
     * @param  {type} event: any        browser event
     * @param  {type} action: string    the action, ie: Initiate Validation, Rejected...
     * @param  {type} statusObject: any current topic's status object
     * @param  {type} callback: any     callback function to return
     * @return {type}                   callback containing error and next status bundle
     */
    StatusChangeService.prototype.nonAppStatusChange = function (event, action, statusObject, callback) {
        var statBundle = {};
        //First step, ensure the program profile is available
        //if (this.config.programProfileMissing()) {
        if (!this.config.proProfileLoaded) {
            this.getProfileMissingDetails(statBundle); //Set prompt details
            return callback('bad profile', statBundle);
        }
        //Check what the next status is based on current one
        var currentStatus = statusObject.status_no;
        var newStatus;
        var newSubStatus;
        var newStatusDesc;
        var newSubStatusDesc;
        var newDefaultSub;
        var nextSubStatuses;
        if (action === 'Initiate Validation') {
            newStatus = 4; //Validation
            newStatusDesc = 'Validation';
            //The automated sub-status for Validation should be Unassigned (4-1), but since user is manually performing the change, set as Pending BPSO (4-3), 
            newDefaultSub = this.config.getSubStatusBySubStatusNo2(4, 3);
            //newDefaultSub = this.config.getSubStatusesByMainStatusNo(newStatus)[0]; //should be 1
            newSubStatus = newDefaultSub.no;
            newSubStatusDesc = newDefaultSub.txt;
        }
        else if (action === 'Close Disbursement') {
            newStatus = 9; //Rejected
            newStatusDesc = 'Closed'; //pull using config function?
            nextSubStatuses = this.config.getSubStatusesByMainStatusNo(9); //Get the closed subs
            newSubStatus = 1;
            newSubStatusDesc = this.config.getSubStatusBySubStatusNo2(9, newSubStatus).txt; //Get description of that subby
        }
        else {
            newStatus = 8; //Rejected
            newStatusDesc = 'Rejected'; //pull using config function?
            nextSubStatuses = this.config.getSubStatusesByMainStatusNo(8); //Get the rejection subs
            if ([1, 3].indexOf(currentStatus) > -1) {
                newSubStatus = 2; // Eligibility Rejected
            }
            else if ([4].indexOf(currentStatus) > -1) {
                newSubStatus = 4; // Validation or Sales Verfication Rejected - set as Validation for now
            }
            else {
                newSubStatus = 1; // Payment Rejected
            }
            newSubStatusDesc = this.config.getSubStatusBySubStatusNo2(8, newSubStatus).txt; //Get description of that subby
        }
        statBundle.nextStatusDesc = newStatusDesc; //Description to be displayed
        statBundle.nextSubStatusDesc = newSubStatusDesc; //Description to be displayed
        statBundle.nextStatus = newStatus;
        statBundle.nextSubStatus = newSubStatus;
        statBundle.nextSubStatuses = nextSubStatuses;
        statBundle.action = action;
        return callback(null, statBundle);
    };
    /**
     * newPromise - Promise created for the call to the getUsersByRole service...process needs to wait
     * on the results
     *
     * @param  {type} socket: any        socket to make the service call
     * @param  {type} role  : string the role number to search for, ie: role 0 = BPSO Admin
     * @param  {type} cty   : string the country shortname the approvers should have access to, ie: US, GB, DE
     * @return {type}                    Deferred promise once results received
     */
    StatusChangeService.prototype.newPromise = function (socket, role, cty) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 10 seconds...reject
        }, 10000);
        //Make the service call to get the users
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                country: cty,
                function: 'getUsersByRoleApprovals',
                roleNumber: role,
                script: '/approvals/approvals',
                user: this.env.user
            }
        });
        //declare listener for response from the service
        this.socket.forward('approvals.usersbyrole', this.$rootScope);
        this.$rootScope.$on('socket:approvals.usersbyrole', function (event, data) {
            //Once the results of any call to the getUsersByRole service are received...
            _this.deferred.resolve(data.results); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    StatusChangeService.prototype.getCurrentApprovalStatus = function (statusObject) {
        //Grab current main and sub-status
        var currentStatus = statusObject.status_no;
        var currentSubStatus = statusObject.sub_status_no;
        var main = this.config.getMainStatusByMainStatusNo(currentStatus);
        var sub = this.config.getSubStatusBySubStatusNo(main, currentSubStatus);
        //Once done..prepare status object to return.
        var renotifyBundle = {
            nextStatusDesc: main.txt,
            nextSubStatusDesc: sub.txt,
            nextStatus: currentStatus,
            nextSubStatus: currentSubStatus,
            nextStatusObject: sub,
            approvalComplete: false,
            action: '',
            commentsMandatory: false,
            select_approver: '',
            approvalProcess: this.isPreApproval(currentStatus) ? 'Pre-Approval' : 'Approval'
        };
        return renotifyBundle;
    };
    /**
     * getNextRRCStatus - Function to determine next status if Reject, Reverse or Cancel Approval is fired
     *
     * @param  {type} statusObject: any Current topic's Status Object
     * @param  {type} action: string    action, ie: Reject, Reverse Approval or Cancel Approval
     * @return {type}                   An object containing the next status details
     */
    StatusChangeService.prototype.getNextRRCStatus = function (statusObject, action, program) {
        //work out which main status to go back to...should be just current main -1!!
        //Grab current main and sub-status
        var currentStatus = statusObject.status_no;
        var nextStatus = this.settings.getNextMainStatus(currentStatus, program, true);
        var main = this.config.getMainStatusByMainStatusNo(nextStatus);
        var sub = nextStatus === 1 ? this.config.getSubStatusBySubStatusNo2(1, 2) : this.config.getSubStatusBySubStatusNo2(4, 3); //Pending Pre-Approval Initialisation for Received (1)...Pending BPSO for Validation (4)
        var nextSubStatus = sub.no;
        //Once done..prepare status object to return.
        var rcBundle = {
            nextStatusDesc: main.txt,
            nextSubStatusDesc: sub.txt,
            nextStatus: nextStatus,
            nextSubStatus: nextSubStatus,
            nextStatusObject: main,
            approvalComplete: false,
            action: '',
            commentsMandatory: true,
            select_approver: '',
            approvalProcess: this.isPreApproval(currentStatus) ? 'Pre-Approval' : 'Approval'
        };
        return rcBundle;
    };
    /**
     * isPreApproval - Function to determine which Approval Process we are in/about
     * to enter based on current status
     *
     * @param  {type} currentStatus: number Current status, ie: 1 to 9
     * @return {type}                       Returns true in in Pre-Approval; false otherwise
     */
    StatusChangeService.prototype.isPreApproval = function (currentStatus) {
        //Get the program approval stages...based on where we are
        var approvalStages;
        //If at stage 1 about to submit for pre-approval, or in pre-approval
        if ([1, 2].indexOf(currentStatus) > -1) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * getNextApprovalStatus - Function to work out the next approval status based on current status and the
     * Program Profile.
     *
     * @param  {type} statusObject: any Object containing current status details
     * @return {type}                   Object containing details of the next status among other things
     */
    StatusChangeService.prototype.getNextApprovalStatus = function (statusObject, program) {
        //Set flag to determine if the approval process is complete....assume it isn't
        var approvalComplete = false;
        var preApproval = false;
        //Grab current main and sub-status
        var currentStatus = statusObject.status_no;
        var currentSubStatus = statusObject.sub_status_no;
        //Get the program approval stages...based on where we are
        var approvalStages;
        var approvalAmount; //Get the Disbursement amount to be approved. accordingly
        //If at stage 1 about to submit for pre-approval, or in pre-approval
        if (this.isPreApproval(currentStatus)) {
            approvalStages = this.config.proProfile.preapproval_stages;
            approvalAmount = Math.abs(statusObject.approvals.preapproval_amount); // Absolute values so debits are the same as credits
            preApproval = true;
        }
        else {
            approvalStages = this.config.proProfile.approval_stages;
            approvalAmount = Math.abs(statusObject.approvals.approval_amount); // Absolute values so debits are the same as credits
        }
        //Prepate the next statuses
        var nextStatus = currentStatus; //Again assume we won't be changing main status
        var nextSubStatus = currentSubStatus;
        var currentSubIndex; //The index with the approval stages for current status
        //Get the main status object, ie: Pre-Approval or Approval
        var main;
        var subbies;
        var sub;
        var nextStageFound = false; //initialise
        //Check if just starting an approval process, ie: if NOT status is 2 (Pending Pre-Approval) or
        // 5 (Pending Approval)
        if ([2, 5].indexOf(currentStatus) === -1) {
            //If submitting for approval or pre-approval
            nextStatus = preApproval ? 2 : 5; //Set accordingly
            nextSubStatus = approvalStages[0]; //indicating first entry (index 0) of the approval stage array
            main = this.config.getMainStatusByMainStatusNo(nextStatus);
            sub = this.config.getSubStatusBySubStatusNo(main, nextSubStatus);
            //Check if there's a clip level for this stage and if so, is the approval ampount less than
            // the clip...
            if (sub != null && sub.clip > 0 && approvalAmount <= sub.clip) {
            }
            else {
                nextStageFound = true; ///to escape loop
            }
        }
        else {
            main = this.config.getMainStatusByMainStatusNo(nextStatus);
        }
        //Keep looping until next approval stage found
        while (!nextStageFound) {
            //Get the index of the current approval status
            currentSubIndex = approvalStages.indexOf(nextSubStatus);
            //Check if there is another approval stage
            if (currentSubIndex + 1 > approvalStages.length - 1) {
                //If this is the last stage, disbursement can move to Eligibility, Validation or Approved status
                // depending on the program profile...so grab from program profile
                approvalComplete = true;
                //nextStatus = preApproval ? 3 : 5; //Set accordingly...Validation or Approved
                nextStatus = this.settings.getNextMainStatus(nextStatus, program, false);
                nextStageFound = true; ///to escape loop
                main = this.config.getMainStatusByMainStatusNo(nextStatus);
                subbies = main.subs;
                if (!subbies) {
                    nextSubStatus = 1; //Set as 1 if error....there should be a 1!
                }
                else {
                    nextSubStatus = subbies[0].no; //pull first status from the array
                }
                sub = this.config.getSubStatusBySubStatusNo(main, nextSubStatus);
            }
            else {
                //If in the middle of approval set as the next one in the sequence...since already set if submitting
                //if ([2, 5].indexOf(currentStatus) > -1) {
                nextSubStatus = approvalStages[currentSubIndex + 1];
                //}
                //Once we have that, grab the sub-status object that will be set next
                sub = this.config.getSubStatusBySubStatusNo(main, nextSubStatus);
                //Check if there's a clip level for this stage and if so, is the approval ampount less than
                // the clip...
                if (sub != null && sub.clip > 0 && approvalAmount <= sub.clip) {
                }
                else {
                    nextStageFound = true; ///to escape loop
                }
            }
        }
        //Once done..prepare status object to return.  May be a normal main status or an approval status
        var appBundle = {
            nextStatusDesc: main.txt,
            nextSubStatusDesc: sub != null ? sub.txt : null,
            nextStatus: nextStatus,
            nextSubStatus: nextSubStatus,
            nextStatusObject: approvalComplete ? main : sub,
            approvalComplete: approvalComplete,
            action: '',
            commentsMandatory: false,
            select_approver: '',
            approvalProcess: preApproval ? 'Pre-Approval' : 'Approval'
        };
        return appBundle;
    };
    /**
     * getProfileMissingDetails - Function to define the error details within the app bundle should
     * the program profle be missing
     *
     * @param  {type} appBundle: any Object containing the next status etc
     * @return {type}                Same object
     */
    StatusChangeService.prototype.getProfileMissingDetails = function (bundle) {
        bundle.error = true;
        bundle.title = 'Program Profile Missing';
        bundle.textContent = 'It has not been possible to retrieve the Program Profile for this Disbursement.' +
            '  &nbsp;The Profile is required to determine the next status.<p><p>Please contact the <b>DMT System' +
            ' Administrators</b> for guidance.';
        return bundle;
    };
    StatusChangeService.prototype.getPromptDetails = function (appBundle, statusObject) {
        appBundle.title = appBundle.action;
        if (!appBundle.approvalComplete) {
            //If Approval Process not complete
            if (appBundle.action === 'Reject') {
                appBundle.textContent = 'You have chosen to <b>Reject</b> this Disbursement. &nbsp;Should you choose to continue, ' +
                    'the Disbursement will be moved back to the ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') +
                    ' status and all previous Approvals will be wiped.';
            }
            else if (appBundle.action === 'Reverse Approval') {
                appBundle.textContent = 'You have chosen to <b>Reverse</b> the Approvals for this Disbursement. &nbsp;' +
                    'Should you choose to continue, ' +
                    'the Disbursement will be moved back to the ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') +
                    ' status and all previous Approvals will be wiped.';
            }
            else if (appBundle.action === 'Renotify Approver') {
                appBundle.textContent = 'You have chosen to <b>Renotify</b> the Approver for this Disbursement. &nbsp;' +
                    'You can choose to either resend notification to the current selected Approver, <b>' +
                    statusObject.approvals.selected_approver_name + '</b>, or choose someone else.';
                appBundle.selected_approver = {
                    email: statusObject.approvals.selected_approver_email,
                    name: statusObject.approvals.selected_approver_name
                };
            }
            else if (appBundle.action === 'Cancel Approval') {
                appBundle.textContent = 'You have chosen to <b>Cancel</b> the Approval process for this Disbursement. &nbsp;' +
                    'Should you choose to continue, ' +
                    'the Disbursement will be moved back to the ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') +
                    ' status, and notification sent to <b>' + statusObject.approvals.selected_approver_name +
                    '</b> informing them to ignore the request. &nbsp;All previous Approvals will also be wiped.';
                appBundle.selected_approver = {
                    email: statusObject.approvals.selected_approver_email,
                    name: statusObject.approvals.selected_approver_name
                };
            }
            else {
                if (appBundle.action.indexOf('Submit') > -1) {
                    appBundle.textContent = 'You are about to enter the ' + appBundle.approvalProcess + ' process. &nbsp;Once' +
                        ' submitted, the Disbursement content will become be locked and uneditable.';
                }
            }
        }
        else {
            //If just starting or the end
            if (appBundle.action.indexOf('Submit') > -1) {
                appBundle.title = appBundle.action + ' for ' + appBundle.approvalProcess;
                appBundle.textContent = 'This Disbursement does not require Approval. &nbsp;Should you choose to continue, the ' +
                    'Disbursement will be moved' +
                    ' directly to ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') + ' status. &nbsp;Continue?';
            }
            else {
                appBundle.textContent = 'This is the final ' + appBundle.approvalProcess +
                    ' Stage.  &nbsp;Should you choose to continue, the Disbursement will be moved' +
                    ' to ' + this.getBoldStatus(appBundle.nextStatusObject.txt, 'blue') + ' status.';
            }
        }
        return appBundle;
    };
    StatusChangeService.prototype.getBoldStatus = function (status, colour) {
        return '<span class="ibm-textcolor-' + colour + '-50"><b>' + status + '</b></span>';
    };
    /**
         * Function to allow System Admin to resolve errors.
         *
         * @param {*} event
         * @param {*} topic
         * @param {Function} callback
         *
         * @memberOf StatusChangeService
         */
    StatusChangeService.prototype.resolveError = function (event, errors, callback) {
        var _this = this;
        var resolveBundle = { action: 'Resolve Error' };
        resolveBundle.errors = errors;
        //Set default error first non-resolved one
        for (var i = 0; i < errors.err.length; i++) {
            if (errors.err[i].resolved === false) {
                resolveBundle.error = errors.err[i];
                break;
            }
        }
        var items = {
            resolveBundle: resolveBundle
        };
        //Show to-be-solved-error selection prompt dialog...
        this.Dialog.updateValidForm(event, items, 'resolveerror-dialog.html').then(function (dResult) {
            //Hereunder we do setup values to send back to server for document update
            //Let's set error as solved
            dResult.locals.resolveBundle.error.resolved = true;
            //let's calculate cycletime
            dResult.locals.resolveBundle.error.cycle = _this.dateDiffInDays(new Date(resolveBundle.error.timestamp), new Date());
            //let's update unresolved errors count
            dResult.locals.resolveBundle.errors.unresolved = dResult.locals.resolveBundle.errors.unresolved - 1;
            //let's track down resolve timestamp
            dResult.locals.resolveBundle.error.resolvedtimestamp = new Date().getTime();
            //let's track down who resolved error
            dResult.locals.resolveBundle.error.resolveuser = _this.env.user.email;
            return callback(false, dResult.locals.resolveBundle);
        }).catch(function () {
            return callback(true); //User cancelled
        });
    };
    /**
     * Function to allow System Admin to roll-back / update the status in certain scenarios
     *
     * @param {*} event
     * @param {*} topic
     * @param {Function} callback
     *
     * @memberOf StatusChangeService
     */
    StatusChangeService.prototype.rollbackStatus = function (event, topic, callback) {
        var _this = this;
        var rollBundle = { action: 'Rollback Status' };
        var mainStatuses = [];
        var nextStatuses = [];
        var setAside = false;
        rollBundle.currentStatus = topic.topic.status.status_no; //Set current status
        rollBundle.helpText = 'The statuses available are based on the current status.';
        //rollBundle.deleteAttach = false;
        mainStatuses.push(topic.topic.status.status_no); //As well as allowing to change current sub-status
        if (topic.topic.status.status_no === 4) {
            //If in a system-set status, ie: set aside - only allow Elig roll-back - no not permit
            //sub-status change since user should use the 'revert' button for that
            if (this.config.isSystemStatus(topic.topic.status.status_no, topic.topic.status.sub_status_no)) {
                //   mainStatuses.splice(0, 1); //Lose current status
                rollBundle.helpText += ' &nbsp;Use the \'Revert\' button instead should you wish to update the Calculations.';
            }
            //If in Validation status...allow to go back to Elig as well as updating sub-status
            mainStatuses.push(3);
            // If in a Set-Aside status...only allow sub-status change to other set aside statuses
            if (this.config.isSystemStatus(topic.topic.status.status_no, topic.topic.status.sub_status_no)) {
                setAside = true;
                mainStatuses.push(4);
            }
        }
        else if (topic.topic.status.status_no === 7) {
            // rollBundle.helpText += ' &nbsp;You are only permitted to update the Sub-Status.';
            //If PAID...move back to APPROVED (if went through approval process) or VALIDATION if not
            if (topic.topic.status.approvals.approval_required && topic.topic.status.approvals.complete) {
                mainStatuses.push(6); //only allow to go back to Approved
            }
            else {
                mainStatuses.push(4); //only allow to go back to Validation
            }
        }
        else if ([8, 9].indexOf(topic.topic.status.status_no) > -1) {
            rollBundle.helpText += ' &nbsp;You are only permitted to update the Sub-Status, or Roll-back to the status prior to ';
            //If Closed or Paid...allow sub-status change, or to go back to the status it was Closed/Rejected
            if (angular.isDefined(topic.topic.status.close_details)) {
                mainStatuses.push(topic.topic.status.close_details.close_status); //back to status closed at
                rollBundle.helpText += 'Closure.';
            }
            else if (angular.isDefined(topic.topic.status.rejection_details)) {
                mainStatuses.push(topic.topic.status.rejection_details.reject_status); //back to status rejected at
                rollBundle.helpText += 'Rejection.';
            }
            //it should allow Sys_admin to allow to roll back to validation
            mainStatuses.push(4);
        }
        //Build array of the permitted main status objects
        angular.forEach(this.settings.status_cfg, function (status) {
            if (mainStatuses.indexOf(status.no) > -1) {
                //Loop through all the subs...set the ignore flag to those that should be available...
                angular.forEach(status.subs, function (sub) {
                    //So...if the not current status or Unassigned status (since that would involve owner table update)
                    if (sub.txt === 'Unassigned' || (sub.no === topic.topic.status.sub_status_no && status.no === topic.topic.status.status_no)) {
                        sub.ignore = true;
                    }
                    else {
                        sub.ignore = false;
                        if (sub.system) {
                            sub.systemOverride = true; // Override temporarily
                        }
                        else {
                            // If not system and current status is set aside, skip non-system statuses
                            if (status.no === 4 && setAside && !sub.system) {
                                sub.ignore = true;
                            }
                        }
                    }
                });
                nextStatuses.push(status);
            }
        });
        rollBundle.nextStatuses = nextStatuses; //Set the main statuses
        rollBundle.nextStatus = nextStatuses[nextStatuses.length - 1]; //Set default main status as the upper bound of the array
        //Set default sub-status...ie: the first non-system one
        for (var i = 0; i < rollBundle.nextStatus.subs.length; i++) {
            //if (angular.isUndefined(rollBundle.nextStatus.subs[i].system) || !rollBundle.nextStatus.subs[i].system) {
            if (!rollBundle.nextStatus.subs[i].ignore) {
                rollBundle.nextSubStatus = rollBundle.nextStatus.subs[i];
                break;
            }
        }
        var items = {
            rollBundle: rollBundle
        };
        //Show rejection dialog...
        this.Dialog.updateValidForm(event, items, 'rollback-dialog.html').then(function (dResult) {
            if (topic.status.status_no !== rollBundle.nextStatus.no) {
                _this.mainStatusChange = true;
            }
            // Wipe the appBundle property in the status service that may still be set if rollback
            // takes place after an approval/rejection...if the appBundle remains it may trigger
            // and approval email
            _this.appBundle = null;
            //Update display
            topic.temp_ext.status = rollBundle.nextStatus.txt;
            topic.temp_ext.sub_status = rollBundle.nextSubStatus.txt;
            return callback(false, dResult.locals.rollBundle);
        }).catch(function () {
            return callback(true); //User cancelled
        });
    };
    StatusChangeService.prototype.updateSetAsideStatus = function (event, topic, callback) {
        return callback();
    };
    StatusChangeService.prototype.moveToPaidStatus = function (event, topic, callback) {
        var _this = this;
        var updateBundle = {};
        updateBundle.paidDate = new Date();
        var item = {
            updateBundle: updateBundle
        };
        this.Dialog.updateValidForm(event, item, 'move-to-paid-comment.html').then(function (dResult) {
            topic.temp_ext.status = 'Paid';
            if (!topic.temp.invoice_flags) {
                topic.temp.invoice_flags = {};
            }
            topic.temp.invoice_flags = topic.topic.invoice_flags;
            topic.temp.invoice_flags.paidDate = new Date(dResult.updateBundle.paidDate);
            var assistCondition = _this.ASSIST_VALUES.includes(topic.topic.sales_assist) ||
                _this.ASSIST_VALUES.includes(topic.topic.sales_assist.type);
            topic.temp_ext.sub_status = assistCondition ? 'Paid as Assist' : 'Paid as Sold';
            return callback(false, dResult);
        }).catch(function () {
            return callback(true); // User cancelled
        });
    };
    StatusChangeService.prototype.overrideProspectCMRs = function (itemObj, event, topic, callback) {
        var item = {
            message: itemObj.message,
            okMessage: 'OK',
            DBG: '',
            DCID: '',
            CMR: '',
            isOverride: false,
            isAutomaticCheck: false,
            cancelMessage: 'Cancel',
            dialogName: itemObj.dialogName,
            addCancel: false
        };
        this.Dialog.updateValidForm(event, item, 'override-prospect.html').then(function (dResult) {
            if (dResult.confirm) {
                return callback(false, dResult);
            }
        }).catch(function () {
            return callback(true); // User cancelled
        });
    };
    StatusChangeService.prototype.passEmbargoCheck = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'Pass Embargo Check',
            isApproved: false,
            isCountryManualReview: false,
            message: 'Please confirm that Embargo Check should be passed:',
            okMessage: 'OK'
        };
        this.Dialog.updateValidForm(event, item, 'embargo-check.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.passCrossBoardEmeaCheck = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'Confirm cross board eligibility',
            isApproved: false,
            isCountryManualReview: false,
            message: 'Please confirm that Cross Board eligibility should be passed:',
            okMessage: 'OK'
        };
        this.Dialog.updateValidForm(event, item, 'cross-board.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.openNotificationPreviewDialog = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'BP Notification',
            message: 'Please confirm that BP Notification should be sent',
            okMessage: 'Send',
            data: {
                mail: topic.mailPreview
            }
        };
        this.Dialog.updateValidForm(event, item, 'notification-mail.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.displayNotificationPreview = function (event, data, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'BP Notification',
            message: 'Bp notification info',
            data: data
        };
        this.Dialog.updateValidForm(event, item, 'notification-mail-preview.html')
            .then(function (dResult) {
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.passCountryManualReview = function (event, topic, callback) {
        var item = {
            addCancel: false,
            cancelMessage: 'Cancel',
            dialogName: 'Pass Manaual Review',
            isApproved: false,
            isCountryManualReview: true,
            message: 'Please confirm that Manual Review should be passed:',
            okMessage: 'OK'
        };
        this.Dialog.updateValidForm(event, item, 'embargo-check.html')
            .then(function (dResult) {
            if (dResult.confirm) {
                return callback(false);
            }
        })
            .catch(function () {
            return callback(true);
        });
    };
    StatusChangeService.prototype.updatePaymentDetailsStatus = function (event, topic, callback) {
        var initialSapResult = topic.topic.calculation.sapResult;
        var updateBundle = Object.assign({}, topic.topic.calculation);
        var status = topic.topic.status;
        var posInArray = { SSA: '', Solution: '', Growth: '', Focus: '', Ctl: '', NewClient: '' };
        var mainStatuses = [];
        var nextStatuses = [];
        var arr;
        // If sapResult doesn't exist, create it
        if (!topic.topic.calculation.sapResult) {
            arr = Object.assign({}, topic.topic.calculation);
            arr.sapResult = [];
            arr = arr.sapResult;
        }
        else {
            arr = topic.topic.calculation.sapResult;
        }
        status.isMoveToPaid = false;
        status.currentStatus = status.status_no; // Set current status
        status.helpText = 'The statuses available are based on the current status.';
        mainStatuses.push(status.status_no); // As well as allowing to change current sub-status
        // Validation or Approved
        if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'Y') {
            status.isMoveToPaid = true;
            mainStatuses.push(7);
            // Build array of the permitted main status objects
            angular.forEach(this.settings.status_cfg, function (status) {
                if (mainStatuses.indexOf(status.no) > -1) {
                    // Loop through all the subs...set the ignore flag to those that should be available...
                    angular.forEach(status.subs, function (sub) {
                        // So...if the not current status or Unassigned status (since that would involve owner table update)
                        if (sub.txt === 'Unassigned' || (sub.no === status.sub_status_no && status.no === status.status_no)) {
                            sub.ignore = true;
                        }
                        else {
                            sub.ignore = false;
                            if (sub.system) {
                                sub.systemOverride = true; // Override temporarily
                            }
                        }
                    });
                    nextStatuses.push(status);
                }
            });
            status.nextStatuses = nextStatuses; // Set the main statuses
            status.nextStatus = nextStatuses[nextStatuses.length - 1]; // Set default main status as the upper bound of the array
            // Set default sub-status...ie: the first non-system one
            for (var i = 0; i < status.nextStatus.subs.length; i++) {
                if (!status.nextStatus.subs[i].ignore) {
                    status.nextSubStatus = status.nextStatus.subs[i];
                    break;
                }
            }
        }
        // Set Aside
        if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'N' && !topic.isSetAside()) {
            status.isMoveToPaid = true;
            if (status.status_no === 6) {
                mainStatuses[0] = 4;
            }
            // Build array of the permitted main status objects
            angular.forEach(this.settings.status_cfg, function (status) {
                if (mainStatuses.indexOf(status.no) > -1) {
                    // Loop through all the subs...set the ignore flag to those that should be available...
                    angular.forEach(status.subs, function (sub) {
                        // So...if the not current status or Unassigned status (since that would involve owner table update)
                        if (sub.txt === 'Unassigned' || (sub.no === status.sub_status_no && status.no === status.status_no) || !sub.txt.includes('Set Aside')) {
                            sub.ignore = true;
                        }
                        else if (sub.txt.includes('Set Aside')) {
                            sub.ignore = false;
                            if (sub.system) {
                                sub.systemOverride = true; // Override temporarily
                            }
                        }
                    });
                    nextStatuses.push(status);
                }
            });
            status.nextStatuses = nextStatuses; // Set the main statuses
            status.nextStatus = nextStatuses[nextStatuses.length - 1]; // Set default main status as the upper bound of the array
            // Set default sub-status...ie: the first non-system one
            for (var i = 0; i < status.nextStatus.subs.length; i++) {
                if (status.nextStatus.subs[i].txt.includes('Set Aside')) {
                    status.nextSubStatus = status.nextStatus.subs[i];
                    break;
                }
            }
        }
        // If sapResult empty or 'Set Aside', fill it
        if (arr.length === 0 || arr === 'Set Aside') {
            arr = []; // Replace sapResult in variable arr with empty array
            // If goe off it is Set Aside, create variable with value 'Set Aside' to fill object and later paste this string in input field
            var setAsideInInput = void 0;
            if (updateBundle.goe === 'N') {
                setAsideInInput = 'Set Aside';
            }
            // If order value total exist for current incentive program push object
            if (updateBundle.totalOrderValues.orderTotalSSA) {
                arr.push({
                    'iaugru': 'Y72',
                    'SSA': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalSolution) {
                arr.push({
                    'iaugru': 'Y79',
                    'Solution': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalNewClient) {
                arr.push({
                    'iaugru': 'Y81',
                    'NewClient': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalFocus) {
                arr.push({
                    'iaugru': 'Y90',
                    'Focus': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalGrowth) {
                arr.push({
                    'iaugru': 'Y92',
                    'Growth': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            if (updateBundle.totalOrderValues.orderTotalCtl) {
                arr.push({
                    'iaugru': 'NOT_AVAILABLE',
                    'Ctl': setAsideInInput || 'Failed - See Errors',
                    'sapResultTime': new Date().getTime(),
                    'paidTimestamp': new Date().getTime()
                });
            }
            // Create initial Date if it move to Set Aside
            if (((status.status_no === 4 || status.status_no === 6) && updateBundle.complete === false && updateBundle.goe === 'N') || status.status_no === 7) {
                updateBundle.paidTimestamp = new Date();
                updateBundle.sapResultTime = updateBundle.paidTimestamp;
            }
            updateBundle.sapResult = arr;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].hasOwnProperty('SSA')) {
                posInArray.SSA = i;
            }
            if (arr[i].hasOwnProperty('Solution')) {
                posInArray.Solution = i;
            }
            if (arr[i].hasOwnProperty('NewClient')) {
                posInArray.NewClient = i;
            }
            if (arr[i].hasOwnProperty('Focus')) {
                posInArray.Focus = i;
            }
            if (arr[i].hasOwnProperty('Growth')) {
                posInArray.Growth = i;
            }
            if (arr[i].hasOwnProperty('Ctl')) {
                posInArray.Ctl = i;
            }
        }
        // Convert timestamp to date and use it in datepicker
        for (var _i = 0, _a = updateBundle.sapResult; _i < _a.length; _i++) {
            var entry = _a[_i];
            entry.paidTimestamp = new Date(entry.paidTimestamp);
            entry.sapResultTime = entry.paidTimestamp;
        }
        // Convert timestamp to date if it Set Aside
        if (((status.status_no === 4 || status.status_no === 6) && updateBundle.complete !== false && updateBundle.goe === 'N') || status.status_no === 7) {
            var entry = updateBundle;
            entry.paidTimestamp = new Date(entry.paidTimestamp);
            entry.sapResultTime = entry.paidTimestamp;
        }
        // Remove any comments
        updateBundle.comments = '';
        var items = {
            initialSapResult: initialSapResult,
            status: status,
            updateBundle: updateBundle,
            nameOfCvrSSA: posInArray.SSA,
            nameOfCvrSolution: posInArray.Solution,
            nameOfCvrNewClient: posInArray.NewClient,
            nameOfFocus: posInArray.Focus,
            nameOfGrowth: posInArray.Growth,
            nameOfCtl: posInArray.Ctl,
            ssaLabel: topic.topic.version && topic.topic.version >= this.OPP_VERSION_4 ? 'SSA' : 'CVR SSA',
            seLabel: topic.topic.version && topic.topic.version >= this.OPP_VERSION_4 ? 'Engagement' : 'CVR Solution'
        };
        if (status.status_no === 4 && topic.topic.complete.errorsArray.all.length > 0) {
            var items_1 = {
                icon: 'WARN',
                message: 'One or more sections for this stage are still to be completed before you can Submit.' +
                    ' &nbsp;Please check for any red thumbs before attempting again.',
                title: 'Update Details'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        else if (status.status_no === 4 && status.approvals.approval_required && updateBundle.complete === false) {
            var items_2 = {
                icon: 'WARN',
                message: 'This Disbursement needs Approval before it can be ' + (updateBundle.goe === 'Y' ? 'sent to SAP for payment' : 'Set Aside') + '. Please select Submit for Approval from Your Actions',
                title: 'Update Details'
            };
            this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        else {
            // Show rejection dialog...
            this.Dialog.updateValidForm(event, items, 'updatePaymentDetails-dialog.html').then(function (dResult) {
                // Convert date to timestamp to save it in cloudant
                for (var _i = 0, _a = dResult.updateBundle.sapResult; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    entry.paidTimestamp = Date.parse(entry.paidTimestamp);
                    entry.sapResultTime = entry.paidTimestamp;
                }
                // Convert initial Date to timestamp if it move to Set Aside
                if (((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'N') || status.status_no === 7) {
                    var entry = dResult.updateBundle;
                    entry.paidTimestamp = Date.parse(entry.paidTimestamp);
                    entry.sapResultTime = entry.paidTimestamp;
                }
                // Save new status if Validation or Approved
                if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'Y') {
                    status.status_no = 7;
                }
                // Save new status if Set Aside
                if ((status.status_no === 4 || status.status_no === 6) && updateBundle.goe === 'N') {
                    status.status_no = 4;
                }
                return callback(false, dResult.locals);
            }).catch(function () {
                return callback(true); // User cancelled
            });
        }
    };
    StatusChangeService.prototype.reAssignUser = function (event, topic, callback) {
        var items = {
            updateBundle: topic
        };
        //Show rejection dialog...
        this.Dialog.updateValidForm(event, items, 'reAssignUser-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    StatusChangeService.prototype.approvalProcess = function (event, action, topicBundle, callback) {
        var _this = this;
        var appBundle;
        var statusObject = topicBundle.status;
        var program = topicBundle.program;
        var country = topicBundle.country;
        //First step, ensure the program profile is available
        if (!this.config.proProfileLoaded) {
            this.getProfileMissingDetails(appBundle); //Set prompt details
            return callback('bad profile', appBundle);
        }
        //Now work out what the next status will be
        if (this.isRollBackAction(action)) {
            appBundle = this.getNextRRCStatus(statusObject, action, program);
        }
        else if (action === 'Renotify Approver') {
            appBundle = this.getCurrentApprovalStatus(statusObject);
        }
        else {
            appBundle = this.getNextApprovalStatus(statusObject, program);
        }
        appBundle.action = action;
        appBundle.error = false;
        //If no sub found (due to cock-up with Admin data)...
        if (appBundle.nextStatusObject === null) {
            appBundle.error = true;
            appBundle.title = 'Status Profile Missing';
            appBundle.textContent = 'It has not been possible to retrieve the Approval profile for stage number ' +
                appBundle.nextStatus + '-' + appBundle.nextSubStatus + '. &nbsp;It would appear to be missing from the Cloudant document.' +
                '<p><p>Please contact the <b>DMT System Administrators</b> for guidance.';
            return callback('missing status', appBundle);
        }
        //If next approval stage is peer, get the users from server
        if (!appBundle.approvalComplete && appBundle.nextStatusObject.peer) {
            //Which group?
            var roleNumber = '0'; //assume it's BPSO...99% of cases
            if (!appBundle.nextStatusObject.bpso) {
                roleNumber = '1'; //Non-BPSO admin
            }
            this.newPromise(this.socket, roleNumber, country).then(function (theUsers) {
                appBundle.nextStatusObject.users = theUsers;
                if (theUsers.length > 0) {
                    //Make call to add the appropriate call details
                    _this.getPromptDetails(appBundle, statusObject);
                    _this.setDefaultSelectedApprover(appBundle);
                    return callback(null, appBundle);
                }
                else {
                    appBundle.error = true;
                    appBundle.title = 'Unable to Retrieve Approvers';
                    appBundle.textContent = 'It has not been possible to retrieve the authorised Approvers for the ' +
                        'next stage from the server. &nbsp;It would appear there are no such \'' + appBundle.nextStatusObject.txt +
                        '\' users in the DB2 table. &nbsp;Please try again.<p><p>' +
                        'If the problem persists, please contact the <b>DMT System Administrators</b> for guidance.';
                    return callback('Unable to retrieve the Approvers list from server', appBundle);
                }
            }, function (noUsersReturnedInTime) {
                appBundle.error = true;
                appBundle.title = 'Unable to Retrieve Approvers';
                appBundle.textContent = 'It has not been possible to retrieve the authorised Approvers for the ' +
                    'next stage from the server. &nbsp;Please try again.<p><p>' +
                    'If the problem persists, please contact the <b>DMT System Administrators</b> for guidance.';
                return callback('Unable to retrieve the Approvers list from server', appBundle);
            });
        }
        else {
            //If still in the approval stage, ensure the app bundle has approvers!
            if (!this.isRollBackAction(action) && !appBundle.approvalComplete &&
                (appBundle.nextStatusObject.users === undefined || appBundle.nextStatusObject.users.length === 0)) {
                appBundle.error = true;
                appBundle.title = 'No Approvers';
                appBundle.textContent = 'There are currently no Approvers set up in the Status Configuration Profile for ' +
                    'the next Approval stage: \'' + appBundle.nextStatusObject.txt + '\' [' + appBundle.nextStatus + '-' +
                    appBundle.nextStatusObject.no +
                    '].  &nbsp;It is likely the last remaining approver(s) lost their DMT access ' +
                    'recently.  &nbsp;Please contact the <b>DMT System Administrators</b> immediately to have the correct Approvers added.';
                return callback('No Approvers found in Status Configuration profile for stage', appBundle);
            }
            //Make call to add the appropriate call details
            this.getPromptDetails(appBundle, statusObject);
            if ([2, 5].indexOf(appBundle.nextStatus) > -1) {
                this.setDefaultSelectedApprover(appBundle);
            }
            return callback(null, appBundle);
        }
    };
    StatusChangeService.prototype.rejectDisbursement = function (event, topic, callback) {
        var _this = this;
        //Call initiateValidation code from Status module...will return a bundle
        this.nonAppStatusChange(event, 'Rejected', topic.topic.status, function (err, rejBundle) {
            rejBundle.config = _this.config; //Add the config in so the getSubStatusByDesc can be called
            rejBundle.setSubStatus = function () {
                this.nextSubStatus = this.config.getSubStatusByDesc(8, this.nextSubStatusDesc).no;
            };
            var items = {
                rejBundle: rejBundle
            };
            //Show rejection dialog...
            _this.Dialog.updateValidForm(event, items, 'reject-dialog.html').then(function (dResult) {
                //If user continues...
                //Add status the disbursement was rejected at as well as reason code and comments
                if (angular.isUndefined(topic.topic.status.rejection_details)) {
                    topic.topic.status.rejection_details = {};
                    topic.temp.status.rejection_details = {};
                }
                topic.temp.status.rejection_details.reject_reason = dResult.locals.rejBundle.rejectionReason.code + ' - ' + dResult.locals.rejBundle.rejectionReason.desc;
                topic.temp.status.rejection_details.reject_status = topic.topic.status.status_no;
                topic.temp.status.rejection_details.reject_comments = dResult.locals.rejBundle.comments;
                //Update display
                topic.temp_ext.status = rejBundle.nextStatusDesc;
                topic.temp_ext.sub_status = rejBundle.nextSubStatusDesc;
                //Make call to save
                _this.mainStatusChange = true;
                return callback(false, dResult.locals.rejBundle);
            }).catch(function () {
                return callback(true); //User cancelled
            });
        });
    };
    StatusChangeService.prototype.closeDisbursement = function (event, topic, callback) {
        var _this = this;
        //Call initiateValidation code from Status module...will return a bundle
        this.nonAppStatusChange(event, 'Close Disbursement', topic.topic.status, function (err, closeBundle) {
            closeBundle.config = _this.config; //Add the config in so the getSubStatusByDesc can be called
            closeBundle.setSubStatus = function () {
                this.nextSubStatus = this.config.getSubStatusByDesc(9, this.nextSubStatusDesc).no;
            };
            var items = {
                closeBundle: closeBundle
            };
            //Show close dialog...
            _this.Dialog.updateValidForm(event, items, 'close-dialog.html').then(function (dResult) {
                //If user continues...
                //Add status the disbursement was rejected at as well as reason code and comments
                if (angular.isUndefined(topic.topic.status.close_details)) {
                    topic.topic.status.close_details = {};
                    topic.temp.status.close_details = {};
                }
                topic.temp.status.close_details.close_reason = dResult.locals.closeBundle.closeReason.code + ' - ' + dResult.locals.closeBundle.closeReason.desc;
                topic.temp.status.close_details.close_status = topic.topic.status.status_no;
                topic.temp.status.close_details.close_comments = dResult.locals.closeBundle.comments;
                //Update display
                topic.temp_ext.status = closeBundle.nextStatusDesc;
                topic.temp_ext.sub_status = closeBundle.nextSubStatusDesc;
                //Make call to save
                _this.mainStatusChange = true;
                return callback(false, dResult.locals.closeBundle);
            }).catch(function () {
                return callback(true); //User cancelled
            });
        });
    };
    StatusChangeService.prototype.setDefaultSelectedApprover = function (appBundle) {
        //Set initial select value for dropdown
        if (appBundle.selected_approver) {
            //If selected approver is set, ie: Cancel Approval or Renotify...set as that
            appBundle.select_approver = appBundle.selected_approver.name;
        }
        else {
            //Otherwise set as first name
            appBundle.select_approver = appBundle.nextStatusObject.users[0].name;
        }
    };
    StatusChangeService.prototype.statusChange = function (statusObject, topic_ext, action, comments) {
        statusObject = this.calculateOwnership(statusObject);
        action = angular.isUndefined(action) ? 'Status Change' : action;
        var currentMainStatus = topic_ext.status_no;
        var currentSubStatus = topic_ext.sub_status_no;
        var newMainStatus = statusObject.status_no;
        var newSubStatus = statusObject.sub_status_no;
        var event = action;
        var maChange = false;
        var ssChange = false;
        var newHist = this.getNewHistoryObject(event, null, null, comments);
        if (newMainStatus !== currentMainStatus) {
            maChange = true;
            ssChange = true; //By default
        }
        else {
            ssChange = true;
        }
        //If simply renotifying the approver...just add that history element
        if (action === 'Renotify Approver') {
            newHist.desc = 'Approval Notification sent to \'' + statusObject.approvals.selected_approver_email + '\'';
            newHist.new_owner = '-';
            statusObject.history.push(newHist);
            return statusObject;
        }
        //angular.forEach(this.config.tempData.rows, (mainStatus) => {
        angular.forEach(this.settings.status_cfg, function (mainStatus) {
            //loop until new main status desc found
            if (mainStatus.no === newMainStatus) {
                //Now loop through the main statuses sub-statuses
                angular.forEach(mainStatus.subs, function (subStatus) {
                    if (subStatus.no === newSubStatus && ssChange) {
                        if (maChange) {
                            newHist.desc = 'Status changed to \'' + mainStatus.txt +
                                '\' and Sub-Status changed to \'' + subStatus.txt + '\'';
                        }
                        else {
                            newHist.desc = 'Sub-Status changed to \'' + subStatus.txt + '\'';
                        }
                        newHist.new_owner = subStatus.owner;
                        statusObject.history.push(newHist); //Add sub-status history entry
                    }
                });
            }
        });
        return statusObject;
    };
    /**
     * Function to extract users who should not be in the Approvers list..ie: the Assignee and any people
     * who have already approved
     */
    StatusChangeService.prototype.cleanApprovers = function (approvers, exclude) {
        if (angular.isUndefined(approvers)) {
            return approvers;
        }
        var ii = 0;
        // Loop through the array of users who should be excluded
        for (var _i = 0, exclude_1 = exclude; _i < exclude_1.length; _i++) {
            var bod = exclude_1[_i];
            ii = 0; // Reset counter
            // Loop through the approvers
            for (var _a = 0, approvers_1 = approvers; _a < approvers_1.length; _a++) {
                var app = approvers_1[_a];
                // If the name to exlude is in there...lose it
                if (bod === app.email) {
                    approvers.splice(ii, 1);
                    break; // leave the loop
                }
                ii++; // iterate the counter
            }
        }
        return approvers;
    };
    /**
    * calculateOwnership - Function to calculate the ownership cycle time for a status change
    *
    * @param  {type} statusHistoryLog: any Disibursement Status History Log object, ie: topic.status.history_log
    * @param  {type} cycleTimes: any       Disbursement Status Cycle Times object, ie: topic.status.cycle_times
    * @return {type}                       cycle_time object to be pushed to Disbursement's history log
    */
    StatusChangeService.prototype.calculateOwnership = function (statusObject) {
        //Loop back thorough the history log and grab the last status change...basically, anything
        // is a status change other than an Assignment or Reassignment
        //Grab the last history log entry from the disbursement
        var scFound = false;
        var heIndexCount = statusObject.history.length - 1;
        var historyObj;
        //Loop from back to front until an entry is found where owner is not -
        for (var i = heIndexCount; i >= 0; i--) {
            historyObj = statusObject.history[i];
            if (historyObj.new_owner !== '-') {
                break;
            }
        }
        //Grab the ownership
        var owner = historyObj.new_owner; //ie:  Billing, BPSO etc
        //Grab the timestamp
        var lastHistoryDate = new Date(historyObj.timestamp);
        //Work out the difference in days
        var rightNow = new Date();
        var cycle = this.dateDiffInDays(lastHistoryDate, rightNow);
        //Look for owner's cycle in the cycle_times object
        var newOwner = true; //assume it won't be there
        statusObject.cycle_times.some(function (cycleObj, index) {
            if (cycleObj[owner] !== undefined) {
                //If found iterate the number of days
                //  console.log('cycle already exists...');
                var newCycle = cycleObj[owner] = cycleObj[owner] + cycle; //REMOVE the 5 after testing
                statusObject.cycle_times[owner] = newCycle;
                newOwner = false;
                return true;
            }
        });
        //If not found, create new object and dump in
        if (newOwner) {
            statusObject.cycle_times.push((_a = {}, _a[owner] = cycle, _a));
        }
        /*console.log('Refreshed Cycle Times = ' + statusObject.cycle_times.length);
        statusObject.cycle_times.forEach((obj) => {
            console.log(obj);
        }); */
        return statusObject;
        var _a;
    };
    StatusChangeService.prototype.getNewHistoryObject = function (event, desc, owner, comments) {
        var newHist = {
            // TODO need not to take time from client, because it can be wrong on user machine.
            // Somewhere it's overrided by timestamp from server, but may be somewhere not...
            timestamp: new Date().getTime(),
            event: event,
            user: this.env.user.email,
            desc: desc,
            new_owner: owner,
            comments: comments
        };
        return newHist;
    };
    //call from site.body.component once saves status confirmed
    StatusChangeService.prototype.sendEmail = function (logRef, oppNum) {
        if (this.appBundle === null || angular.isUndefined(this.appBundle) || (angular.isDefined(this.appBundle) && this.appBundle.action === 'Reverse Approval')) {
            return; //no email required if sub-status change or reversal
        }
        var sendTo;
        var subject;
        var message = this.appBundle.comments;
        var title;
        var template;
        if (angular.isDefined(this.appBundle.selected_approver)) {
            sendTo = this.appBundle.selected_approver.email;
            if (this.appBundle.action === 'Cancel Approval') {
                title = 'Cancel Approval';
                subject = 'DMT - Cancel Approval' + ' - ' + logRef;
            }
            else {
                title = this.appBundle.nextStatusObject.txt;
                subject = 'DMT - Pending ' + this.appBundle.approvalProcess + ' - ' + logRef;
            }
        }
        else {
            sendTo = this.appBundle.owner;
            if (this.appBundle.action === 'Reject') {
                title = 'Rejected';
                subject = 'DMT - Rejected' + ' - ' + logRef;
            }
            else {
                title = 'Approved';
                subject = 'DMT - Approved' + ' - ' + logRef;
            }
        }
        //sendTo = this.env.user.email; //  REMOVE THIS AFTER TESTING
        var email = {
            id: logRef,
            title: title,
            to: [sendTo],
            subject: subject,
            message: message,
            opp: oppNum,
            bpName: '',
            fromwho: this.env.user.email,
            template: 'approval-process',
            type: 'mailing',
            event: 'invitation'
        };
        // console.log(email);
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendApprovalEmail',
                script: '/approvals/approvals',
                emailBundle: email,
                token: this.env.user.token
            }
        });
    };
    StatusChangeService.prototype.dateDiffInDays = function (a, b) {
        var _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    };
    StatusChangeService.$inject = ['$rootScope', '$timeout', '$q', 'socket', 'env', 'config', '$mdDialog',
        'DTS', 'Dialog', 'settings', 'notify'];
    return StatusChangeService;
}());
angular
    .module('application')
    .service('status', StatusChangeService);

//# sourceMappingURL=status.js.map
